import { render, staticRenderFns } from "./use-rule.vue?vue&type=template&id=15281380&lang=pug&"
import script from "./use-rule.vue?vue&type=script&lang=js&"
export * from "./use-rule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports